import { Injectable } from "@angular/core";
import { CrossTabCommunicationHandler } from "@modules/common/models/cross-tab-communication-handler";

declare global {
    interface Window {
        attachEvent: (eventName: string, callback: (e: StorageEvent) => void) => void;
    }
}

@Injectable({
    providedIn: 'root'
})
export class CrossTabCommunicationService {
    constructor() {
        if (window.addEventListener) {
            window.addEventListener('storage', e => this.onStorage(e));
        } else if (window.attachEvent) {
            window.attachEvent('onStorage', e => this.onStorage(e));
        }
    }

    public register(handler: CrossTabCommunicationHandler): void {
        this._handlers[handler.key] = this._handlers[handler.key] || [];
        this._handlers[handler.key].push(handler);
    }

    public sendMessage(msg: { key: string, msg: any }): void {
        let json = JSON.stringify(msg.msg);
        localStorage.setItem(msg.key, json);
        localStorage.removeItem(msg.key);
    }

    private onStorage(e: StorageEvent): void {
        e = e || window.event as StorageEvent;
        if (e && e.key) {
            let handlers = this._handlers[e.key];
            if (handlers) {
                for (let handler of handlers) {
                    handler.handler(e);
                }
            }
        }
    }

    private _handlers: { [key: string]: CrossTabCommunicationHandler[] } = {};
}
